var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { cssClassMap } from '../../../constants/SportCssMap';
import MatchScoresAdapter from '../../adapters/MatchScoresAdapter';
import Stream from './Stream';
import playImg from '../../../assets/img/play_stream_img.svg';
import pinnedImg from '../../../assets/img/pin_img.svg';
import pauseImg from '../../../assets/img/pause_stream_img.svg';
import unpinnedImg from '../../../assets/img/unpin_img.svg';
import { FormattedMessage } from 'react-intl';
import statisticsComponentFactory from './statistics/statisticsComponentFactory';
import { defineMessages } from 'react-intl';
import { bindActionCreators } from 'redux';
import { openAuthModal as openAuthModalAction } from '../../../actions/auth/creators/Login';
import { getPeriodInfo } from './statistics/utils';
import * as PeriodType from '../../../constants/Period';
import streamIcon from '../../../assets/img/icons/stream.svg';
import trackerIcon from '../../../assets/img/icons/tracker.svg';
import { fetchBetradarStreamUrl, toggleStream } from '../../../actions/creators/betradar';
var messages = defineMessages({
    hide_stream: {
        id: 'hide.hide_stream',
        defaultMessage: 'hide.hide_stream'
    },
    watch_stream: {
        id: 'watch.watch_stream',
        defineMessages: 'watch.watch_stream'
    }
});
var LiveHeader = /** @class */ (function (_super) {
    __extends(LiveHeader, _super);
    function LiveHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            streamClicked: false,
            pinned: false,
            user: _this.props.user
        };
        _this.toggleShowStream = function () {
            var user = _this.props.user;
            if (user && user.accountId) {
                _this.setState(function (prevState) { return ({
                    streamClicked: !prevState.streamClicked
                }); });
            }
            else {
                _this.props.openAuthModalAction({ onlineTranslation: true });
            }
        };
        _this.pinTheStream = function (event) {
            event.stopPropagation();
            _this.setState({
                pinned: true,
            });
        };
        _this.unpinTheStream = function () {
            _this.setState({
                pinned: false,
            });
        };
        _this.toggleBetradar = function () {
            var _a = _this.props, betradar = _a.betradar, match = _a.match;
            var radarId = match.get('radarId');
            _this.props.toggleStream();
            if (!betradar.showStream) {
                window.SIR('removeWidget', document.querySelector('.match-widget'));
                _this.props.fetchBetradarStreamUrl(radarId);
            }
        };
        return _this;
    }
    LiveHeader.renderStatistics = function (props, short) {
        if (short === void 0) { short = false; }
        var match = props.match, scores = props.scores, gridLocalization = props.gridLocalization, additionalScores = props.additionalScores, periodInfo = props.periodInfo;
        var sportId = match.get('realSportId');
        if (match.get('radarId'))
            return null;
        var Renderer = statisticsComponentFactory(sportId);
        var statisticsProps = {
            periodInfo: periodInfo,
            match: match,
            scores: scores,
            gridLocalization: gridLocalization,
            additionalScores: additionalScores,
            short: short
        };
        return _jsx(Renderer, __assign({}, statisticsProps));
    };
    ;
    LiveHeader.prototype.render = function () {
        var _a = this.props, match = _a.match, leagueName = _a.leagueName, gridLocalization = _a.gridLocalization, scores = _a.scores, client = _a.client, betradar = _a.betradar;
        var sportId = match.get('sportId');
        var sportCssName = cssClassMap[sportId];
        var periodInfo = getPeriodInfo(match, gridLocalization);
        var matchPhase = periodInfo.matchPhase;
        var matchScoresIds = match.get('scores');
        var scoresMap = matchScoresIds.map(function (m) { return scores.get(m); });
        var additionalScoresIds = MatchScoresAdapter.getAdditionalScores(sportId, scoresMap);
        var additionalScores = additionalScoresIds.map(function (m) { return scores.get(m); });
        var props = {
            periodInfo: periodInfo,
            match: match,
            scores: scoresMap,
            gridLocalization: gridLocalization,
            additionalScores: additionalScores
        };
        var remark = match.get('remark');
        var channel = match.get('channel') || null;
        var src;
        if (channel !== null) {
            var myRegexp = /url:(.*)/;
            var regexArray = myRegexp.exec(channel);
            if (regexArray) {
                src = regexArray[1];
            }
        }
        if (matchPhase === PeriodType.FINISHED) {
            return (_jsxs("div", { children: [_jsx("div", __assign({ className: "backward ".concat(sportCssName) }, { children: _jsxs("div", __assign({ className: 'header' }, { children: [_jsx("div", { className: 'back', onClick: this.props.goBack }), _jsx("div", __assign({ className: 'name' }, { children: leagueName }))] })) })), match.get('firstTeam') && LiveHeader.renderStatistics(props), remark && _jsx("div", __assign({ className: 'remark' }, { children: remark }))] }));
        }
        var streamClicked = this.state.streamClicked;
        var pinned = this.state.pinned;
        var streamClassName = streamClicked ? 'live-watch hide-live' : 'live-watch';
        var text = streamClicked ? __assign({}, messages.hide_stream) : __assign({}, messages.watch_stream);
        var imgSource = streamClicked ? pauseImg : playImg;
        var pinStreamClassName = pinned ? 'pin-stream' : 'unpin-stream';
        var mainBlock = pinned ? 'main-block' : '';
        var mainBlockInner = pinned ? 'main-block_inner' : '';
        var leagueNames = !pinned ? leagueName : match.get('name');
        var showStreamBtn = src && client.country === 'KG';
        return (_jsx("div", __assign({ className: mainBlock }, { children: _jsxs("div", __assign({ className: mainBlockInner }, { children: [_jsx("div", __assign({ className: "backward ".concat(sportCssName, " ").concat(betradar.streamUrl && 'with-toggle') }, { children: _jsxs("div", __assign({ className: 'header' }, { children: [pinned && _jsx("img", { className: 'fasten-icon', onClick: this.unpinTheStream, src: unpinnedImg, alt: '' }), _jsx("div", { className: 'back', onClick: this.props.goBack }), _jsx("div", __assign({ className: 'name' }, { children: leagueNames })), betradar.streamUrl && (_jsx("img", { className: "betradar-toggler", src: betradar.showStream ? trackerIcon : streamIcon, alt: "", onClick: this.toggleBetradar }))] })) })), showStreamBtn &&
                        _jsxs("div", __assign({ className: "section ".concat(streamClassName, " ").concat(pinStreamClassName) }, { children: [_jsxs("div", __assign({ onClick: this.toggleShowStream, className: 'live-watch-inner' }, { children: [_jsx("img", { className: 'stream-logo', src: imgSource, alt: '' }), _jsx(FormattedMessage, __assign({}, text, { className: 'live-watch_btn' }))] })), streamClicked && _jsx("img", { className: 'pin-stream-img', onClick: this.pinTheStream, src: pinnedImg, alt: '' })] })), streamClicked && _jsx(Stream, { src: src }), !pinned && match.get('firstTeam') && LiveHeader.renderStatistics(props), !pinned && remark && _jsx("div", __assign({ className: 'remark' }, { children: remark })), pinned && match.get('firstTeam') && LiveHeader.renderStatistics(props, true)] })) })));
    };
    return LiveHeader;
}(React.Component));
LiveHeader.propTypes = {
    leagueName: PropTypes.string.isRequired,
    match: PropTypes.object.isRequired,
    gridLocalization: PropTypes.object.isRequired,
    scores: PropTypes.object,
    sportId: PropTypes.any.isRequired,
    languageId: PropTypes.number.isRequired
};
function mapStateToProps(state, props) {
    var section = props.section;
    var scores = state.application.getIn([section, 'scores']);
    var client = state.application.get('client');
    var betradar = state.betradar;
    var user = state.auth.user;
    return {
        scores: scores,
        client: client,
        user: user,
        betradar: betradar,
    };
}
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    openAuthModalAction: openAuthModalAction,
    fetchBetradarStreamUrl: fetchBetradarStreamUrl,
    toggleStream: toggleStream
}, dispatch); };
LiveHeader = connect(mapStateToProps, mapDispatchToProps)(LiveHeader);
export default LiveHeader;



// WEBPACK FOOTER //
// ./src/components/grid/event/liveHeader.jsx